import { ExclamationTriangleIcon } from 'assets/icons'
import { ButtonLoading } from 'components/Buttons'
import { Modal, ModalContent, ModalIcon } from 'components/Modal'
import FormattedMessage from 'utils/FormattedMessage'
import { useTranslation } from 'utils'

type Props = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const KioskNonAnonModal = ({ open, onCancel, onConfirm }: Props) => {
  const intl = useTranslation()

  return (
    <Modal
      open={open}
      onClose={onCancel}
      submitButton={
        <ButtonLoading onClick={onConfirm}>
          <FormattedMessage id='kiosk.nonAnonModal.confirm' />
        </ButtonLoading>
      }
      cancelButton={
        <ButtonLoading onClick={onCancel}>
          <FormattedMessage id='kiosk.nonAnonModal.cancel' />
        </ButtonLoading>
      }
    >
      <ModalIcon
        icon={
          <ExclamationTriangleIcon className='h-6 w-6 stroke-orange-600' aria-hidden='true' />
        }
      />
      <ModalContent
        title={intl({ id: 'kiosk.nonAnonModal.title' })}
        description={intl({ id: 'kiosk.nonAnonModal.description' })}
      />
    </Modal>
  )
}
